import { type MaterialSymbolName } from "./material.js";

/**
 * @since 7.1.0
 */
export const DEFAULT_MATERIAL_SYMBOL_NAMES = [
  "keyboard_arrow_left",
  "close_small",
  "close",
  "check_box_outline_blank",
  "check_box",
  "indeterminate_check_box",
  "arrow_drop_down",
  "error",
  "keyboard_arrow_down",
  "keyboard_arrow_right",
  "menu",
  "notifications",
  "visibility",
  "radio_button_unchecked",
  "radio_button_checked",
  "cancel",
  "check",
  "arrow_upward",
  "upload",
] satisfies readonly MaterialSymbolName[];
